<template>
  <section id="card-holder" class="card-holder">
    <slot></slot>
    <!-- placeholders for a better flexbox experience -->
    <div class="ph"></div>
    <div class="ph"></div>
    <div class="ph"></div>
  </section>
</template>

<script>
export default {
  name: 'CardHolder'
}
</script>

<style lang="scss" scoped>
.card-holder {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  //top: -13px;
  //justify-content: space-around;
}

:deep(.product-card) {
  margin: 13px 9px;
}

.mobile {
  .card-holder {
    //height: calc(100vh - 47px);
    //margin-left: 6px;
    padding-bottom: 150px;
  }

  :deep(.product-card) {
    margin: 5px;
    max-width: 47%;
  }

  .ph {
    margin: 5px;
  }
}

.ph {
  width: 191px;
  margin: 13px 11px;
}

@media only screen and (min-width: 620px) {
  .card-holder {
    justify-content: flex-start;
  }
}

@media only screen and (min-width: 1024px) {
  .card-holder {
    height: 100%;
  }
}
</style>
